// NOTICE: KAPTION-INTEGRATION — Mock data for Campaign Reports dashboard stories.
// Shapes mirror the wanalytics API (proxied via Kaption::AnalyticsDataService).
// The API returns PRE-AGGREGATED data — do NOT aggregate client-side.

// Totals — from `get_account_metrics`
export const mockTotals = {
  sent: 1247,
  delivered: 1183,
  read: 892,
  replied: 234,
  failed: 64,
  delivery_rate: 94.8,
  read_rate: 75.4,
  reply_rate: 19.8,
  failure_rate: 5.1,
};

// Timeline — from `get_metrics_timeline`
// 7 daily buckets
export const mockTimelineDaily = [
  {
    date: '2026-05-24',
    sent: 145,
    delivered: 138,
    read: 102,
    replied: 26,
    failed: 7,
  },
  {
    date: '2026-05-25',
    sent: 162,
    delivered: 154,
    read: 118,
    replied: 31,
    failed: 8,
  },
  {
    date: '2026-05-26',
    sent: 188,
    delivered: 179,
    read: 141,
    replied: 38,
    failed: 9,
  },
  {
    date: '2026-05-27',
    sent: 201,
    delivered: 192,
    read: 149,
    replied: 41,
    failed: 9,
  },
  {
    date: '2026-05-28',
    sent: 176,
    delivered: 167,
    read: 124,
    replied: 33,
    failed: 9,
  },
  {
    date: '2026-05-29',
    sent: 198,
    delivered: 188,
    read: 142,
    replied: 37,
    failed: 10,
  },
  {
    date: '2026-05-30',
    sent: 177,
    delivered: 165,
    read: 116,
    replied: 28,
    failed: 12,
  },
];

// 30 daily buckets
export const mockTimeline30Days = Array.from({ length: 30 }, (_, i) => {
  const day = String(i + 1).padStart(2, '0');
  // Deterministic pseudo-variation (no Math.random — keeps stories stable)
  const base = 120 + ((i * 37) % 90);
  const sent = base;
  const delivered = Math.round(sent * 0.95);
  const read = Math.round(delivered * 0.76);
  const replied = Math.round(read * 0.26);
  const failed = sent - delivered;
  return { date: `2026-05-${day}`, sent, delivered, read, replied, failed };
});

// Monthly buckets — from `get_metrics_timeline` with granularity=month
export const mockTimelineMonthly = [
  {
    date: '2025-12-01',
    sent: 2840,
    delivered: 2698,
    read: 2034,
    replied: 512,
    failed: 142,
  },
  {
    date: '2026-01-01',
    sent: 3120,
    delivered: 2964,
    read: 2271,
    replied: 598,
    failed: 156,
  },
  {
    date: '2026-02-01',
    sent: 2950,
    delivered: 2802,
    read: 2128,
    replied: 541,
    failed: 148,
  },
  {
    date: '2026-03-01',
    sent: 3410,
    delivered: 3239,
    read: 2510,
    replied: 661,
    failed: 171,
  },
  {
    date: '2026-04-01',
    sent: 3680,
    delivered: 3496,
    read: 2731,
    replied: 728,
    failed: 184,
  },
  {
    date: '2026-05-01',
    sent: 3247,
    delivered: 3083,
    read: 2342,
    replied: 612,
    failed: 164,
  },
];

// Top campaigns — from `get_campaigns`
export const mockTopCampaigns = [
  {
    id: 1,
    title: 'May Promo Blast',
    campaign_type: 'one_off',
    sent: 450,
    delivered: 433,
    read: 351,
    replied: 101,
    failed: 17,
  },
  {
    id: 2,
    title: 'Welcome Sequence',
    campaign_type: 'direct',
    sent: 312,
    delivered: 292,
    read: 222,
    replied: 58,
    failed: 20,
  },
  {
    id: 3,
    title: 'Cart Abandonment Reminder',
    campaign_type: 'direct',
    sent: 268,
    delivered: 255,
    read: 198,
    replied: 47,
    failed: 13,
  },
  {
    id: 4,
    title: 'Weekend Flash Sale',
    campaign_type: 'one_off',
    sent: 241,
    delivered: 228,
    read: 171,
    replied: 39,
    failed: 13,
  },
  {
    id: 5,
    title: 'Product Launch — Aurora',
    campaign_type: 'one_off',
    sent: 219,
    delivered: 209,
    read: 164,
    replied: 44,
    failed: 10,
  },
  {
    id: 6,
    title: 'Re-engagement Push',
    campaign_type: 'direct',
    sent: 187,
    delivered: 173,
    read: 121,
    replied: 22,
    failed: 14,
  },
  {
    id: 7,
    title: 'NPS Survey Follow-up',
    campaign_type: 'direct',
    sent: 164,
    delivered: 158,
    read: 129,
    replied: 51,
    failed: 6,
  },
  {
    id: 8,
    title: 'Loyalty Tier Upgrade',
    campaign_type: 'one_off',
    sent: 142,
    delivered: 137,
    read: 108,
    replied: 29,
    failed: 5,
  },
  {
    id: 9,
    title: 'Appointment Reminders',
    campaign_type: 'direct',
    sent: 118,
    delivered: 114,
    read: 97,
    replied: 33,
    failed: 4,
  },
  {
    id: 10,
    title: 'Holiday Greetings',
    campaign_type: 'one_off',
    sent: 96,
    delivered: 89,
    read: 64,
    replied: 12,
    failed: 7,
  },
];

// Convenience: conversion rates derived for the rates component (matches totals)
export const mockRates = {
  delivery_rate: mockTotals.delivery_rate,
  read_rate: mockTotals.read_rate,
  reply_rate: mockTotals.reply_rate,
  failure_rate: mockTotals.failure_rate,
};

// WhatsApp inboxes — shape mirrors Chatwoot inbox objects (id, name, phone)
// used by the per-inbox dashboard filter.
export const mockInboxes = [
  { id: 101, name: 'BFG WhatsApp', phone_number: '+1 555-0100' },
  { id: 102, name: 'Proderma WhatsApp', phone_number: '+1 555-0200' },
  { id: 103, name: 'Olé WhatsApp', phone_number: '+1 555-0300' },
];

// Campaign list for the individual-campaign multi-select filter — mixed types.
// (Separate from mockTopCampaigns so the filter list can be broader than the
// leaderboard's top 10.)
export const mockFilterCampaigns = [
  { id: 1, title: 'May Promo Blast', campaign_type: 'one_off' },
  { id: 2, title: 'Welcome Sequence', campaign_type: 'direct' },
  { id: 3, title: 'Cart Abandonment Reminder', campaign_type: 'direct' },
  { id: 4, title: 'Weekend Flash Sale', campaign_type: 'one_off' },
  { id: 5, title: 'Product Launch — Aurora', campaign_type: 'one_off' },
  { id: 6, title: 'Re-engagement Push', campaign_type: 'direct' },
  { id: 7, title: 'NPS Survey Follow-up', campaign_type: 'direct' },
  { id: 8, title: 'Loyalty Tier Upgrade', campaign_type: 'one_off' },
  { id: 9, title: 'Appointment Reminders', campaign_type: 'direct' },
  { id: 10, title: 'Holiday Greetings', campaign_type: 'one_off' },
];
